import { jsx as a } from "react/jsx-runtime";
import { ModalFooter as d, ModalBody as e, ModalHeader as r, Modal as t } from "flowbite-react";
import { theme as m } from "./theme.js";
const l = (o) => /* @__PURE__ */ a(t, { ...o, theme: m }), p = Object.assign(l, {
  Header: r,
  Body: e,
  Footer: d
});
export {
  p as Modal,
  l as ModalComponent
};
